<!--
 * @Description: 
 * @Author: zml
 * @Date: 2023-03-21 11:49:51
 * @LastEditors: zml
 * @LastEditTime: 2025-08-18 10:07:04
-->
<template>
  <div class="about-box">
    <!-- <div class="container detail" v-html="$hs(datas.content,datas.enContent,datas.threeContent)"></div> -->

    <div class="container about_Us">
      <div class="about_usContents">
        <div class="usContents_title">
          {{ $hs("关于","About","") }}
          <span style="color: red;">{{ $hs("我们","Us","") }}</span>
        </div>
        <div class="usContents_big">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>></div>
        <div
          class="usContents_text1"
        >{{ $hs("立丰玩具公司成立于 2021 年，拥有深厚的行业专业知识。我们的团队拥有 14 年的跨境危机管理经验（包括 2008 年金融危机和 2019 年疫情）。","Lifeng Toys,founded in 2021 with deep-rooted industry expertise.Our team brings 14 years of cross-bordercrisis management experience (2008 Financial Crisis / 2019 Pandemic).","") }}</div>
        <div
          class="usContents_text2"
        >{{ $hs("凭借在玩具领域的丰富经验，我们能够为客户提供从设计到生产的整套玩具解决方案：","With rich experience in toys line,we can provide our customers end-to-end toy solutions:","") }}</div>
        <div class="usContents_text3">
          <ul>
            <li>
              <div class="circle"></div>
              <div>{{ $hs("精准采购：从设计到认证再到大规模生产，提供全面的 OEM/ODM 服务支持。","Precision Sourcing: Full OEM/ODM support from design → certification → mass production","") }}</div>
            </li>
            <li>
              <div class="circle"></div>
              <div>{{ $hs("智能物流：对全球 20 条航运路线上的集装箱进行实时监控","Smart Logistics: Real-time container monitoring across 20 global shipping routes","") }}</div>
            </li>
            <li>
              <div class="circle"></div>
              <div></div>
              <div>{{ $hs("区域适应：欧盟/美国合规要求与新兴市场定制化需求","Regional Adaptation: EU/US compliance & emerging market customization","") }}</div>
            </li>
          </ul>
        </div>
        <div
          class="usContents_text4"
        >{{ $hs("秉持“双赢合作”的理念，我们欢迎合作伙伴携手共创美好未来。","Guided by the 'Win-Win Collaboration' philosophy, we welcome partners to co-create the future together.","") }}</div>
      </div>
      <div class="about_images">
        <img src="../../assets/about_image1.png" alt />
      </div>
    </div>
    <div class="container about_imageList">
      <img src="../../assets/about_image2.png" alt />
      <img src="../../assets/about_image3.png" alt />
      <img src="../../assets/about_image4.png" alt />
    </div>
    <div class="container about_Advantages">
      <div class="about_Advantages_title">{{ $hs("我们的优势","Our Advantages","") }}</div>
      <div
        class="about_Advantages_contents"
      >{{ $hs("我们不仅敢于许下承诺，而且也能够履行这些承诺。","We Not Only Dare To Make Promises, But Also Can Fulfill Them","") }}</div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { getCompanyInfo } from '@/api/home'

export default {
  name: 'pageDetail',
  props: {
    datas: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    ...mapGetters('setting', {
      getSetting: 'get_setting'
    })
  },
  data() {
    return {
      datas: {}
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 获取公司简介
      getCompanyInfo().then(res => {
        if (res.success) {
          this.datas = res.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.about_Us {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;

  .about_usContents {
    width: 600px;
    .usContents_title {
      font-size: 32px;
      font-weight: 400;
      color: #222222;
      margin-bottom: 20px;
    }
    .usContents_big {
      font-size: 20px;
      font-weight: 400;
      text-align: left;
      color: #222222;
      letter-spacing: 2.4px;
      margin-bottom: 30px;
    }
    .usContents_text1,
    .usContents_text2 {
      width: 510px;
      font-size: 16px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
      text-align: left;
      color: #222222;
      line-height: 26px;
    }
    .usContents_text2 {
      margin-top: 20px;
    }
    .usContents_text3 {
      margin-top: 20px;
      ul li {
        display: flex;
        align-items: center;
        width: 500px;
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: left;
        color: #222222;
        margin: 5px 0;
      }
      .circle {
        width: 5px;
        height: 5px;
        background-color: black;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
    .usContents_text4 {
      width: 510px;
      font-size: 16px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
      text-align: left;
      color: #222222;
      margin-top: 20px;
    }
  }
  .about_images {
    width: 600px;
  }
}
.about_imageList {
  display: flex;
  justify-content: space-between;
  margin-top: 35px;
  img {
    width: 380px;
    height: 285px;
  }
}
.about_Advantages {
  .about_Advantages_title {
    height: 47px;
    font-size: 32px;
    font-weight: 700;
    text-align: center;
    color: #222222;
    margin-top: 50px;
  }
  .about_Advantages_contents {
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    color: #222222;
    margin-bottom: 50px;
    margin-top: 10px;
  }
}
</style>
